import type { CoreReadRouter } from "@bt/core";
import type { InstallationReport } from "@bt/domain/report";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { inferRouterOutputs } from "@trpc/server";
import { createTRPCContext } from "@trpc/tanstack-react-query";

/**
 * Core's read API, through the admin app's server (/api/core/trpc), which adds the read token;
 * the browser never talks to core itself.
 */
export const { TRPCProvider, useTRPC } = createTRPCContext<CoreReadRouter>();

export const coreClient = createTRPCClient<CoreReadRouter>({
  links: [httpBatchLink({ url: "/api/core/trpc" })],
});

export type CoreOutputs = inferRouterOutputs<CoreReadRouter>;

/**
 * The latest report of `installation.get`, typed as the contract has it. tRPC's output types turn
 * objects that keep unknown fields (`z.looseObject`) into `{}`; the JSON is the report itself.
 */
export function reportOf(detail: CoreOutputs["installation"]["get"]): InstallationReport | null {
  return detail.report as InstallationReport | null;
}
